module.exports = __webpack_public_path__ + "img/vipgroup_accessblue_icon.18b58a05.png";